/**
 * Files API — upload, download URL, delete.
 */

import { apiFetch, API_BASE } from './core'

export const files = {
    /** Список метаданных файлов (без бинарника). Фильтры: entity_type, entity_id. */
    list: (params = {}) => {
        const qs = new URLSearchParams()
        if (params.entity_type) qs.set('entity_type', params.entity_type)
        if (params.entity_id) qs.set('entity_id', params.entity_id)
        const q = qs.toString()
        return apiFetch(`/files/${q ? `?${q}` : ''}`)
    },
    upload: (file, entityType = 'general', entityId = '') => {
        const formData = new FormData()
        formData.append('file', file)
        const qs = new URLSearchParams({ entity_type: entityType, ...(entityId ? { entity_id: entityId } : {}) }).toString()
        return apiFetch(`/files/upload?${qs}`, {
            method: 'POST',
            body: formData,
        })
    },
    download: (fileId) => `${API_BASE}/files/${fileId}`,
    delete: (fileId) => apiFetch(`/files/${fileId}`, { method: 'DELETE' }),
}
